/* ═══════════════════════════════════════════════════════════════════
   COREVIAN EXECUTIVE DEMO — ISOLATED PRESENTATION LAYER
   ───────────────────────────────────────────────────────────────────
   This file is the Executive Demo presentation layer. It is deployed
   to the existing Shopify asset slot referenced in corevian-university.liquid
   and now reads approved controlled-document text from the companion static
   asset corevian-executive-demo-documents.js:

       <script src="{{ 'corevian-executive-demo.js' | asset_url }}"></script>

   No .liquid edit, no other production file edit, no new script tag.

   SAFETY / ISOLATION
   - No Supabase client is created or referenced anywhere in this file.
   - No production table, row, or record is read or written.
   - All data below is the corrected 56-person fictional dataset,
     verified: 56 unique ids, 56 unique names, sole Morgan Reed
     (NOT AUTHORIZED), Devon Whitfield distinct and unrelated.
   - This file NEVER touches window.getCorevianSupabaseClient,
     workforceReadinessRows, or any other live production data handle.
   - The Corevian Operating System / Bible is not referenced anywhere
     in this file, directly or indirectly.

   INTEGRATION METHOD (verified against real source, not assumed)
   - renderWorkforceReadiness() in corevian-university-2.js already
     contains a guarded hook:
         if (demoMode && typeof renderDemoWorkforce === 'function') {
           renderDemoWorkforce(); return;
         }
     This file supplies that function. Zero changes to the live file
     were needed for Workforce Readiness.
   - renderCompetencyEvaluation(), renderFieldTrainingReadiness(),
     renderOperationalEndorsements(), renderOperationalAuthorization(),
     and renderRecertificationTracking() have NO equivalent hook —
     verified by direct inspection, each one unconditionally shows a
     permission-denied message whenever demoMode is true, because the
     canX() guards they call are defined as `!demoMode && [...]`.
     Calling showView('competency') etc. in Demo Mode today would
     show that error, not a demo screen. To fix this WITHOUT editing
     the live file, this module wraps window.showView with a thin,
     additive shim: known-broken-in-demo view names are intercepted
     only while demoMode is true; every other view name (including
     'workforce', which already works) is passed through unchanged to
     the original function.
   - openQualificationPassport(userId) and openEmployeeAssignmentEligibility
     read from workforceReadinessRows, a real production variable that
     is never populated in Demo Mode. This file never calls those
     functions. Demo employee rows call this file's own
     openDemoQualificationPassport()/openDemoAssignmentEligibility()
     instead — entirely separate functions, so the real ones are never
     invoked, wrapped, or risked.
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // ───────────────────────────────────────────────────────────────
  // CORRECTED SIMULATED WORKFORCE (56 records)
  // Identical to the approved demo-simulated/demo-workforce-corrected.js
  // reference file. Embedded here (rather than a second script tag) so
  // this project adds exactly one file and zero .liquid changes.
  // ───────────────────────────────────────────────────────────────
  const DEMO_WORKFORCE = [
  {"name":"Jordan Ellis","status":"READY FOR ASSIGNMENT","scope":"General Clinical Courier","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":1},
  {"name":"Morgan Reed","status":"NOT AUTHORIZED","scope":"General Clinical Courier","training":"PASS","competency":"NOT QUALIFIED","field":"NOT READY","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":2},
  {"name":"Jordan Brooks","status":"READY FOR ASSIGNMENT","scope":"Pharmaceutical Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":3},
  {"name":"Jordan Carter","status":"READY FOR ASSIGNMENT","scope":"Medical Device Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":4},
  {"name":"Jordan Davis","status":"READY FOR ASSIGNMENT","scope":"Blood Product Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":5},
  {"name":"Jordan Foster","status":"READY FOR ASSIGNMENT","scope":"General Clinical Courier","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":6},
  {"name":"Jordan Grant","status":"READY FOR ASSIGNMENT","scope":"Lab Specimen Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":7},
  {"name":"Jordan Hayes","status":"READY FOR ASSIGNMENT","scope":"Pharmaceutical Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":8},
  {"name":"Jordan Irving","status":"READY FOR ASSIGNMENT","scope":"Medical Device Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":9},
  {"name":"Jordan James","status":"READY FOR ASSIGNMENT","scope":"Blood Product Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":10},
  {"name":"Jordan King","status":"READY FOR ASSIGNMENT","scope":"General Clinical Courier","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":11},
  {"name":"Jordan Lewis","status":"READY FOR ASSIGNMENT","scope":"Lab Specimen Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":12},
  {"name":"Jordan Moore","status":"READY FOR ASSIGNMENT","scope":"Pharmaceutical Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":13},
  {"name":"Jordan Nelson","status":"READY FOR ASSIGNMENT","scope":"Medical Device Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":14},
  {"name":"Morgan Ellis","status":"READY FOR ASSIGNMENT","scope":"Blood Product Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":15},
  {"name":"Devon Whitfield","status":"READY FOR ASSIGNMENT","scope":"General Clinical Courier","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":16},
  {"name":"Morgan Brooks","status":"READY FOR ASSIGNMENT","scope":"Lab Specimen Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":17},
  {"name":"Morgan Carter","status":"READY FOR ASSIGNMENT","scope":"Pharmaceutical Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":18},
  {"name":"Morgan Davis","status":"READY FOR ASSIGNMENT","scope":"Medical Device Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":19},
  {"name":"Morgan Foster","status":"READY FOR ASSIGNMENT","scope":"Blood Product Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":20},
  {"name":"Morgan Grant","status":"READY FOR ASSIGNMENT","scope":"General Clinical Courier","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":21},
  {"name":"Morgan Hayes","status":"READY FOR ASSIGNMENT","scope":"Lab Specimen Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":22},
  {"name":"Morgan Irving","status":"READY FOR ASSIGNMENT","scope":"Pharmaceutical Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":23},
  {"name":"Morgan James","status":"READY FOR ASSIGNMENT","scope":"Medical Device Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":24},
  {"name":"Morgan King","status":"READY FOR ASSIGNMENT","scope":"Blood Product Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":25},
  {"name":"Morgan Lewis","status":"READY FOR ASSIGNMENT","scope":"General Clinical Courier","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":26},
  {"name":"Morgan Moore","status":"READY FOR ASSIGNMENT","scope":"Lab Specimen Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":27},
  {"name":"Morgan Nelson","status":"READY FOR ASSIGNMENT","scope":"Pharmaceutical Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":28},
  {"name":"Avery Ellis","status":"READY FOR ASSIGNMENT","scope":"Medical Device Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":29},
  {"name":"Avery Reed","status":"READY FOR ASSIGNMENT","scope":"Blood Product Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":30},
  {"name":"Avery Brooks","status":"READY FOR ASSIGNMENT","scope":"General Clinical Courier","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":31},
  {"name":"Avery Carter","status":"READY FOR ASSIGNMENT","scope":"Lab Specimen Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":32},
  {"name":"Avery Davis","status":"READY FOR ASSIGNMENT","scope":"Pharmaceutical Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":33},
  {"name":"Avery Foster","status":"READY FOR ASSIGNMENT","scope":"Medical Device Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"CURRENT","id":34},
  {"name":"Avery Grant","status":"ACTION REQUIRED","scope":"Blood Product Transport","training":"PASS","competency":"REASSESSMENT REQUIRED","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":35},
  {"name":"Avery Hayes","status":"ACTION REQUIRED","scope":"General Clinical Courier","training":"PASS","competency":"PENDING","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":36},
  {"name":"Avery Irving","status":"ACTION REQUIRED","scope":"Lab Specimen Transport","training":"PASS","competency":"REASSESSMENT REQUIRED","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":37},
  {"name":"Avery James","status":"ACTION REQUIRED","scope":"Pharmaceutical Transport","training":"PASS","competency":"PENDING","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":38},
  {"name":"Avery King","status":"ACTION REQUIRED","scope":"Medical Device Transport","training":"PASS","competency":"REASSESSMENT REQUIRED","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":39},
  {"name":"Avery Lewis","status":"ACTION REQUIRED","scope":"Blood Product Transport","training":"PASS","competency":"PENDING","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":40},
  {"name":"Avery Moore","status":"ACTION REQUIRED","scope":"General Clinical Courier","training":"PASS","competency":"REASSESSMENT REQUIRED","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":41},
  {"name":"Avery Nelson","status":"ACTION REQUIRED","scope":"Lab Specimen Transport","training":"PASS","competency":"PENDING","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":42},
  {"name":"Taylor Ellis","status":"ACTION REQUIRED","scope":"Pharmaceutical Transport","training":"PASS","competency":"REASSESSMENT REQUIRED","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":43},
  {"name":"Taylor Reed","status":"NOT AUTHORIZED","scope":"Medical Device Transport","training":"PASS","competency":"NOT QUALIFIED","field":"NOT READY","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":44},
  {"name":"Taylor Brooks","status":"NOT AUTHORIZED","scope":"Blood Product Transport","training":"PASS","competency":"NOT QUALIFIED","field":"NOT READY","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":45},
  {"name":"Taylor Carter","status":"NOT AUTHORIZED","scope":"General Clinical Courier","training":"PASS","competency":"NOT QUALIFIED","field":"NOT READY","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":46},
  {"name":"Taylor Davis","status":"NOT AUTHORIZED","scope":"Lab Specimen Transport","training":"PASS","competency":"NOT QUALIFIED","field":"NOT READY","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":47},
  {"name":"Taylor Foster","status":"NOT AUTHORIZED","scope":"Pharmaceutical Transport","training":"PASS","competency":"NOT QUALIFIED","field":"NOT READY","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":48},
  {"name":"Taylor Grant","status":"NOT AUTHORIZED","scope":"Medical Device Transport","training":"PASS","competency":"NOT QUALIFIED","field":"NOT READY","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":49},
  {"name":"Taylor Hayes","status":"RENEWAL DUE","scope":"Blood Product Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"DUE SOON","id":50},
  {"name":"Taylor Irving","status":"RENEWAL DUE","scope":"General Clinical Courier","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"DUE SOON","id":51},
  {"name":"Taylor James","status":"RENEWAL DUE","scope":"Lab Specimen Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"DUE SOON","id":52},
  {"name":"Taylor King","status":"RENEWAL DUE","scope":"Pharmaceutical Transport","training":"PASS","competency":"QUALIFIED","field":"READY","documents":"CURRENT","authorization":"AUTHORIZED","renewal":"DUE SOON","id":53},
  {"name":"Taylor Lewis","status":"TRAINING INCOMPLETE","scope":"Medical Device Transport","training":"INCOMPLETE","competency":"PENDING","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":54},
  {"name":"Taylor Moore","status":"TRAINING INCOMPLETE","scope":"Blood Product Transport","training":"INCOMPLETE","competency":"PENDING","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":55},
  {"name":"Taylor Nelson","status":"TRAINING INCOMPLETE","scope":"General Clinical Courier","training":"INCOMPLETE","competency":"PENDING","field":"PENDING","documents":"CURRENT","authorization":"NOT AUTHORIZED","renewal":"CURRENT","id":56}
];

  const JORDAN_ID = (DEMO_WORKFORCE.find(e => e.name === 'Jordan Ellis') || {}).id ?? null;
  const MORGAN_ID = (DEMO_WORKFORCE.find(e => e.name === 'Morgan Reed') || {}).id ?? null;

  const state = { quickFilter: 'ALL', search: '', eligibilityService: null };

  function demoEsc(v) {
    return String(v ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[c]));
  }

  function demoGateLine(ok, label, detail) {
    return `<div style="display:flex;gap:10px;align-items:flex-start;padding:10px 0;border-bottom:1px solid rgba(255,255,255,.07)"><div style="font-weight:800;color:${ok ? '#4ADE80' : '#FCA5A5'};min-width:48px">${ok ? 'PASS' : 'HOLD'}</div><div><div style="font-weight:700;color:var(--white)">${demoEsc(label)}</div><div class="comp-history">${demoEsc(detail)}</div></div></div>`;
  }

  function demoNotice(text) {
    return `<div class="comp-notice">${demoEsc(text)}</div>`;
  }

  const SIM_BANNER = `<div class="comp-notice" style="border-color:rgba(25,181,176,.35)">Simulated demonstration data. This screen is presentation-safe and never reads or writes production employee, qualification, or authorization records.</div>`;

  function explainDemoQualificationStatus(e) {
    const q = demoCategory(e);
    const determination = q.ready ? 'ready' : q.notAuthorized ? 'not_authorized' : 'action_required';
    const authorized = determination !== 'not_authorized';
    const blockers = [];
    const warnings = [];

    const trainingOk = String(e.training).toUpperCase() === 'PASS';
    const competencyOk = String(e.competency).toUpperCase() === 'QUALIFIED';
    const fieldOk = String(e.field).toUpperCase() === 'READY';
    const documentsOk = !/OVERDUE|OUTSTANDING|INCOMPLETE|ACTION REQUIRED/.test(String(e.documents).toUpperCase());
    const authorizedOk = String(e.authorization).toUpperCase() === 'AUTHORIZED';
    const renewalIssue = /DUE|EXPIRED|OVERDUE/.test(String(e.renewal).toUpperCase());

    if (determination === 'not_authorized') {
      if (!trainingOk) blockers.push({ control: 'Final Assessment', status: 'HOLD (' + e.training + ')', explanation: 'The employee has not passed the required Employee Final Assessment.', nextAction: 'Employee must pass the Employee Final Assessment.' });
      if (!competencyOk) blockers.push({ control: 'Hands-On Competency', status: 'NOT QUALIFIED (' + e.competency + ')', explanation: 'A required hands-on competency has not been recorded as Competent.', nextAction: 'A qualified evaluator must complete and record the required competency evaluation.' });
      if (!fieldOk) blockers.push({ control: 'Field Readiness', status: 'NOT READY (' + e.field + ')', explanation: 'Supervised field training has not produced a Ready result.', nextAction: 'Leadership must complete and record a Ready field-training observation.' });
      if (!authorizedOk) {
        const prerequisitesComplete = trainingOk && competencyOk && fieldOk && documentsOk;
        blockers.push({
          control: 'Operational Authorization',
          status: String(e.authorization || 'NOT ISSUED').toUpperCase(),
          explanation: prerequisitesComplete
            ? 'All prerequisite qualification controls are satisfied. A final Operational Authorization decision has not yet been recorded.'
            : 'No Operational Authorization decision has been recorded.',
          nextAction: 'Leadership must complete the final Operational Authorization review and issue a decision.'
        });
      }
    }

    if (!documentsOk) {
      warnings.push({ control: 'Controlled Documents', status: String(e.documents).toUpperCase(), explanation: 'A required document acknowledgment is outstanding or overdue.', nextAction: 'Employee must review and acknowledge the outstanding controlled document.' });
    }
    if (renewalIssue) {
      warnings.push({ control: 'Renewal / Recertification', status: String(e.renewal).toUpperCase(), explanation: 'A recertification requirement is due soon or has expired.', nextAction: 'Leadership must record updated recertification evidence.' });
    }

    let summary;
    if (determination === 'not_authorized') summary = 'NOT AUTHORIZED — ' + blockers.length + ' unresolved control' + (blockers.length === 1 ? '' : 's');
    else if (determination === 'action_required') summary = 'AUTHORIZED — ' + warnings.length + ' item' + (warnings.length === 1 ? '' : 's') + ' requiring attention';
    else summary = 'AUTHORIZED — all required controls are satisfied for the current service scope';

    return {
      determination, authorized, summary,
      serviceScope: authorizedOk ? [e.scope] : [],
      blockers, warnings,
      nextActions: Array.from(new Set(blockers.concat(warnings).map(i => i.nextAction))),
    };
  }

  function demoCategory(e) {
    const status = String(e.status || '').toUpperCase();
    const authorization = String(e.authorization || '').toUpperCase();
    const renewal = String(e.renewal || '').toUpperCase();
    const documents = String(e.documents || '').toUpperCase();

    const renewalIssue = /DUE|EXPIRED|OVERDUE/.test(renewal);
    const documentIssue = /OVERDUE|OUTSTANDING|INCOMPLETE|ACTION REQUIRED/.test(documents);
    const notAuthorized = authorization !== 'AUTHORIZED' || status === 'NOT AUTHORIZED';
    const ready = !notAuthorized && status === 'READY FOR ASSIGNMENT' && !renewalIssue && !documentIssue;
    const actionRequired = !ready && !notAuthorized;

    return { ready, notAuthorized, actionRequired, renewalIssue };
  }

  function demoSummary() {
    return DEMO_WORKFORCE.reduce((a, e) => {
      const q = demoCategory(e);
      if (q.ready) a.ready++;
      if (q.actionRequired) a.action++;
      if (q.notAuthorized) a.blocked++;
      if (q.renewalIssue) a.renewal++;
      return a;
    }, { ready: 0, action: 0, blocked: 0, renewal: 0 });
  }

  function demoFiltered() {
    return DEMO_WORKFORCE.filter(e => {
      const q = demoCategory(e);
      let quick = true;
      if (state.quickFilter === 'READY') quick = q.ready;
      if (state.quickFilter === 'ACTION') quick = q.actionRequired;
      if (state.quickFilter === 'NOT_AUTHORIZED') quick = q.notAuthorized;
      if (state.quickFilter === 'RENEWAL') quick = q.renewalIssue;
      const search = !state.search || String(e.name || '').toLowerCase().includes(state.search.toLowerCase());
      return quick && search;
    });
  }

  function evaluateAssignmentEligibility(employee, requestedService) {
    const steps = [];
    const blockers = [];
    const gate = (label, pass, detail) => {
      steps.push({ gate: label, pass: !!pass, detail });
      if (!pass) blockers.push({ gate: label, detail });
      return pass;
    };

    const isValidRecord = !!employee && typeof employee === 'object' && !!employee.name;
    if (!gate('Active / Valid Record', isValidRecord, isValidRecord ? 'Record present and valid' : 'No valid employee record supplied')) {
      return { eligible: false, requestedService: requestedService || null, steps, blockers };
    }

    const training = String(employee.training || '').toUpperCase();
    const competency = String(employee.competency || '').toUpperCase();
    const field = String(employee.field || '').toUpperCase();
    const documents = String(employee.documents || '').toUpperCase();
    const authorization = String(employee.authorization || '').toUpperCase();
    const status = String(employee.status || '').toUpperCase();
    const renewal = String(employee.renewal || '').toUpperCase();

    gate('Training Requirements', training === 'PASS', employee.training);
    gate('Competency Qualification', competency === 'QUALIFIED', employee.competency);
    gate('Field Readiness', field === 'READY', employee.field);

    const documentIssue = /OVERDUE|OUTSTANDING|INCOMPLETE|ACTION REQUIRED/.test(documents);
    gate('Controlled Documents', documents.length > 0 && !documentIssue, employee.documents);

    const noServiceRequested = !requestedService || requestedService === 'ALL';
    const scopeMatches = noServiceRequested || employee.scope === requestedService;
    gate('Service Scope / Endorsement', scopeMatches, noServiceRequested ? employee.scope : `Endorsed for ${employee.scope}, not ${requestedService}`);

    const authorized = authorization === 'AUTHORIZED' && status !== 'NOT AUTHORIZED';
    gate('Operational Authorization', authorized, employee.authorization);

    const renewalIssue = /DUE|EXPIRED|OVERDUE/.test(renewal);
    gate('Renewal / Recertification', !renewalIssue, employee.renewal);

    return { eligible: blockers.length === 0, requestedService: requestedService || null, steps, blockers };
  }

  function scopesList() {
    return Array.from(new Set(DEMO_WORKFORCE.map(e => e.scope).filter(Boolean))).sort();
  }

  function renderDemoWorkforce() {
    const root = document.getElementById('contentInner');
    if (!root) return;
    const s = demoSummary();
    const list = demoFiltered();

    root.innerHTML = `
      <div class="unit-header">
        <div class="unit-eyebrow">EXECUTIVE QUALIFICATION OVERSIGHT · SIMULATED</div>
        <div class="unit-title">Workforce Readiness Command Center</div>
        <div class="unit-subtitle">Enterprise view of workforce qualification, operational authorization, service scope, renewals, and controlled-document readiness.</div>
      </div>
      ${SIM_BANNER}
      <div class="stat-grid">
        ${demoMetric('ALL', DEMO_WORKFORCE.length, 'Active Workforce')}
        ${demoMetric('READY', s.ready, 'Ready for Assignment')}
        ${demoMetric('ACTION', s.action, 'Action Required')}
        ${demoMetric('NOT_AUTHORIZED', s.blocked, 'Not Authorized')}
        ${demoMetric('RENEWAL', s.renewal, 'Renewals Due / Expired')}
      </div>
      <div class="comp-card" style="padding:16px;margin-top:14px;display:flex;gap:10px;flex-wrap:wrap;align-items:center">
        <input id="demoWorkforceSearch" class="comp-select" style="flex:1;min-width:180px" placeholder="Search employee" value="${demoEsc(state.search)}">
        <button type="button" class="secondary-btn" id="demoClearFilters">Clear Filters</button>
      </div>
      ${demoNotice(list.length + ' of ' + DEMO_WORKFORCE.length + ' simulated employee records shown.')}
      <div id="demoWorkforceList">${list.map(demoEmployeeCard).join('') || demoNotice('No simulated employee matches the current filter.')}</div>
    `;

    document.querySelectorAll('[data-demo-metric]').forEach(el => el.addEventListener('click', () => { state.quickFilter = el.dataset.demoMetric; renderDemoWorkforce(); }));
    const searchInput = document.getElementById('demoWorkforceSearch');
    if (searchInput) searchInput.addEventListener('input', e => { state.search = e.target.value; renderDemoWorkforce(); });
    const clearBtn = document.getElementById('demoClearFilters');
    if (clearBtn) clearBtn.addEventListener('click', () => { state.quickFilter = 'ALL'; state.search = ''; renderDemoWorkforce(); });
  }
  window.renderDemoWorkforce = renderDemoWorkforce;

  function demoMetric(key, value, label) {
    const active = state.quickFilter === key;
    return `<div class="stat-card" data-demo-metric="${key}" style="cursor:pointer;${active ? 'border-color:var(--teal)' : ''}"><div class="stat-num">${value}</div><div class="stat-label">${label}</div></div>`;
  }

  function demoEmployeeCard(e) {
    const q = demoCategory(e);
    const label = q.ready ? 'READY FOR ASSIGNMENT' : q.notAuthorized ? 'NOT AUTHORIZED' : 'ACTION REQUIRED';
    const color = q.ready ? '#4ADE80' : q.notAuthorized ? '#FCA5A5' : '#FBBF24';
    return `
      <div class="comp-card" style="padding:18px;margin-top:12px">
        <div style="display:flex;justify-content:space-between;gap:14px;flex-wrap:wrap;align-items:flex-start">
          <div>
            <div style="font-size:16px;font-weight:800;color:var(--white)">${demoEsc(e.name)}</div>
            <div class="comp-history" style="margin-top:4px">${demoEsc(e.scope)}</div>
          </div>
          <div style="font-weight:800;color:${color}">${label}</div>
        </div>
        <div style="display:flex;gap:10px;margin-top:14px;flex-wrap:wrap">
          <button type="button" class="secondary-btn" onclick="CorevianDemo.openPassport(${e.id})">Qualification Passport</button>
          <button type="button" class="secondary-btn" onclick="CorevianDemo.openEligibility(${e.id})">Assignment Eligibility</button>
        </div>
      </div>`;
  }

  function openDemoQualificationPassport(id) {
    const e = DEMO_WORKFORCE.find(x => x.id === id);
    if (!e) { alert('Simulated employee record could not be found.'); return; }

    const existing = document.getElementById('demoQualificationPassportOverlay');
    if (existing) existing.remove();

    const q = demoCategory(e);
    const statusLabel = q.ready ? 'READY FOR ASSIGNMENT' : q.notAuthorized ? 'NOT AUTHORIZED' : 'ACTION REQUIRED';
    const statusColor = q.ready ? '#4ADE80' : q.notAuthorized ? '#FCA5A5' : '#FBBF24';

    const overlay = document.createElement('div');
    overlay.id = 'demoQualificationPassportOverlay';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(5,17,31,.94);display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow:auto';
    const btnStyle = 'border:1px solid rgba(25,181,176,.45);background:rgba(25,181,176,.08);color:#5ED4CF;border-radius:8px;padding:9px 14px;font-size:12px;font-weight:800;cursor:pointer;';
    overlay.innerHTML = `
     <div class="comp-card" style="max-width:640px;width:100%;padding:28px;position:relative;background:#071526;color:#F7FAFC">
        <button type="button" style="position:absolute;top:16px;right:16px;${btnStyle}" onclick="document.getElementById('demoQualificationPassportOverlay').remove()">Close</button>
        <div class="unit-eyebrow">QUALIFICATION PASSPORT · SIMULATED RECORD</div>
        <div class="unit-title" style="margin-top:6px">${demoEsc(e.name)}</div>
        <div class="unit-subtitle">${demoEsc(e.scope)}</div>
        <div style="margin-top:10px;font-weight:800;color:${statusColor}">${statusLabel}</div>
        ${SIM_BANNER}
        <div style="margin-top:12px">
          ${demoGateLine(String(e.training).toUpperCase() === 'PASS', 'Training', e.training)}
          ${demoGateLine(String(e.competency).toUpperCase() === 'QUALIFIED', 'Hands-On Competency', e.competency)}
          ${demoGateLine(String(e.field).toUpperCase() === 'READY', 'Field Readiness', e.field)}
          ${demoGateLine(!/OVERDUE|OUTSTANDING|INCOMPLETE|ACTION REQUIRED/.test(String(e.documents).toUpperCase()), 'Controlled Documents', e.documents)}
          ${demoGateLine(String(e.authorization).toUpperCase() === 'AUTHORIZED', 'Operational Authorization', e.authorization)}
          ${demoGateLine(!/DUE|EXPIRED|OVERDUE/.test(String(e.renewal).toUpperCase()), 'Renewal / Recertification', e.renewal)}
        </div>
        ${(function () {
          const explanation = explainDemoQualificationStatus(e);
          const isBlocked = !explanation.authorized;
          const headingText = isBlocked ? 'WHY THIS EMPLOYEE IS NOT AUTHORIZED' : 'QUALIFICATION DETERMINATION';
          const headingColor = isBlocked ? '#FCA5A5' : '#4ADE80';
          function renderItem(item, color) {
            return `<div style="margin-top:14px;padding-top:14px;border-top:1px solid rgba(255,255,255,.08)">
              <div style="display:flex;justify-content:space-between;gap:12px;flex-wrap:wrap;align-items:baseline">
                <div style="font-size:14px;font-weight:800;color:var(--white)">${demoEsc(item.control)}</div>
                <div style="font-size:12px;font-weight:800;color:${color}">${demoEsc(item.status)}</div>
              </div>
              <div class="comp-history" style="margin-top:6px">${demoEsc(item.explanation)}</div>
              <div class="comp-history" style="margin-top:4px;color:var(--white)"><strong>Next Required Action:</strong> ${demoEsc(item.nextAction)}</div>
            </div>`;
          }
          const blockersHtml = explanation.blockers.map(b => renderItem(b, '#FCA5A5')).join('');
          const warningsHtml = explanation.warnings.map(w => renderItem(w, '#FBBF24')).join('');
          const positiveBody = explanation.serviceScope.length
            ? `<div class="comp-history" style="margin-top:10px">Required controls are satisfied for: <strong style="color:var(--white)">${demoEsc(explanation.serviceScope.join(', '))}</strong>.</div>`
            : `<div class="comp-history" style="margin-top:10px">Required controls are satisfied for the applicable authorized service scope.</div>`;
          return `<div class="comp-card" style="margin-top:14px;border-left:3px solid ${headingColor};background:var(--navy2)">
            <div class="comp-code" style="color:${headingColor}">${headingText}</div>
            <div style="margin-top:8px;font-weight:800;color:var(--white)">${demoEsc(explanation.summary)}</div>
            ${isBlocked ? blockersHtml : positiveBody}
            ${warningsHtml}
          </div>`;
        })()}
        <div style="margin-top:16px;display:flex;gap:10px;flex-wrap:wrap">
          <button type="button" style="${btnStyle}" onclick="document.getElementById('demoQualificationPassportOverlay').remove();CorevianDemo.openEligibility(${e.id})">View Assignment Eligibility</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
  }

  function openDemoAssignmentEligibility(id) {
    const root = document.getElementById('contentInner');
    if (!root) return;
    const e = DEMO_WORKFORCE.find(x => x.id === id);
    if (!e) { root.innerHTML = demoNotice('Simulated employee record could not be found.'); return; }

    if (!state.eligibilityService) state.eligibilityService = e.scope;
    const service = state.eligibilityService;
    const result = evaluateAssignmentEligibility(e, service);
    const options = scopesList().map(sc => `<option value="${demoEsc(sc)}" ${service === sc ? 'selected' : ''}>${demoEsc(sc)}</option>`).join('');

    root.innerHTML = `
      <div class="unit-header">
        <div class="unit-eyebrow">OPERATIONAL DISPATCH DECISION · EXECUTIVE DEMO EXPANDED VIEW</div>
        <div class="unit-title">Assignment Eligibility — ${demoEsc(e.name)}</div>
        <div class="unit-subtitle">This is the Executive Demo's expanded visualization of the qualification/authorization chain — a dispatch question, not a training result. It independently evaluates all 8 factors below; it is not a representation of production's current downstream eligibility check.</div>
      </div>
      ${SIM_BANNER}
      <div class="comp-card" style="padding:16px;margin-top:14px">
        <label class="comp-label">Requested service</label>
        <select class="comp-select" id="demoEligibilityService">${options}</select>
      </div>
      <div class="comp-card" style="padding:20px;margin-top:14px">
        <div style="font-weight:800;font-size:16px;color:${result.eligible ? '#4ADE80' : '#FCA5A5'}">${result.eligible ? 'ELIGIBLE FOR ASSIGNMENT' : 'NOT ELIGIBLE FOR ASSIGNMENT'}</div>
        ${!result.eligible ? `<div class="comp-history" style="margin-top:8px">Blocked by ${result.blockers.length} control${result.blockers.length === 1 ? '' : 's'}: ${result.blockers.map(b => demoEsc(b.gate) + ' (' + demoEsc(b.detail) + ')').join(', ')}</div>` : ''}
        <div style="margin-top:14px">${result.steps.map(st => demoGateLine(st.pass, st.gate, st.detail)).join('')}</div>
      </div>
      <div class="comp-card" style="padding:16px;margin-top:14px">
        <button type="button" class="secondary-btn" onclick="CorevianDemo.openPassport(${e.id})">View Qualification Passport</button>
        <button type="button" class="secondary-btn" onclick="showView('workforce')" style="margin-left:8px">Back to Workforce Readiness</button>
      </div>
    `;
    const select = document.getElementById('demoEligibilityService');
    if (select) select.addEventListener('change', ev => { state.eligibilityService = ev.target.value; openDemoAssignmentEligibility(id); });
  }

  function demoEmployeeSelector(selectedId, onChangeAttr) {
    const options = DEMO_WORKFORCE.map(e => `<option value="${e.id}" ${e.id === selectedId ? 'selected' : ''}>${demoEsc(e.name)}</option>`).join('');
    return `<select class="comp-select" onchange="${onChangeAttr}">${options}</select>`;
  }

  let selectedDemoCompetencyId = JORDAN_ID;
  function renderDemoCompetencyEvaluation() {
    const root = document.getElementById('contentInner');
    if (!root) return;
    const e = DEMO_WORKFORCE.find(x => x.id === selectedDemoCompetencyId) || DEMO_WORKFORCE[0];
    root.innerHTML = `
      <div class="unit-header"><div class="unit-eyebrow">CONTROLLED COMPETENCY WORKSPACE · SIMULATED</div><div class="unit-title">Competency Evaluation</div><div class="unit-subtitle">Observed, hands-on demonstration of required skills — evaluated separately from training completion.</div></div>
      ${SIM_BANNER}
      <div class="comp-card" style="padding:16px;margin-top:14px"><label class="comp-label">Employee</label>${demoEmployeeSelector(e.id, "CorevianDemo.selectCompetency(this.value)")}</div>
      <div class="comp-card" style="padding:20px;margin-top:14px">
        <div class="comp-code">${demoEsc(e.name)} — ${demoEsc(e.scope)}</div>
        ${demoGateLine(String(e.competency).toUpperCase() === 'QUALIFIED', 'Hands-On Competency', e.competency)}
      </div>`;
  }

  let selectedDemoFieldId = JORDAN_ID;
  function renderDemoFieldTraining() {
    const root = document.getElementById('contentInner');
    if (!root) return;
    const e = DEMO_WORKFORCE.find(x => x.id === selectedDemoFieldId) || DEMO_WORKFORCE[0];
    root.innerHTML = `
      <div class="unit-header"><div class="unit-eyebrow">CONTROLLED FIELD-TRAINING WORKSPACE · SIMULATED</div><div class="unit-title">Field Training &amp; Readiness</div><div class="unit-subtitle">Supervised field performance under real operating conditions, verified before independent dispatch.</div></div>
      ${SIM_BANNER}
      <div class="comp-card" style="padding:16px;margin-top:14px"><label class="comp-label">Employee</label>${demoEmployeeSelector(e.id, "CorevianDemo.selectField(this.value)")}</div>
      <div class="comp-card" style="padding:20px;margin-top:14px">
        <div class="comp-code">${demoEsc(e.name)} — ${demoEsc(e.scope)}</div>
        ${demoGateLine(String(e.field).toUpperCase() === 'READY', 'Field Readiness', e.field)}
      </div>`;
  }

  // ══════════════════════════════════════════════════════════════
  // EXPANDED — Operational Authorization (list view, replaces the
  // single-employee dropdown version). Categories are derived
  // entirely from existing DEMO_WORKFORCE fields (status,
  // authorization, renewal) — nothing new is added to the dataset,
  // so this can never contradict Workforce Readiness's own counts.
  //
  // AWAITING REVIEW = status is ACTION REQUIRED or TRAINING INCOMPLETE
  //   (evidence still forming; no final authorization decision made)
  // DENIED / NOT AUTHORIZED = status is NOT AUTHORIZED
  //   (training passed but a hard qualification gate failed)
  // CONDITIONALLY AUTHORIZED = authorized now, renewal DUE SOON
  //   (authorization holds only while the pending renewal is current)
  // AUTHORIZED = authorized, renewal CURRENT (clean record)
  //
  // Verified against the full 56-record dataset before writing this:
  // AUTHORIZED 33 · AWAITING REVIEW 12 · DENIED 7 · CONDITIONAL 4 —
  // every category has real examples, none are empty.
  // ══════════════════════════════════════════════════════════════
  const authState = { quickFilter: 'ALL', search: '' };

  function demoAuthorizationCategory(e) {
    const status = String(e.status || '').toUpperCase();
    const authorized = String(e.authorization || '').toUpperCase() === 'AUTHORIZED';
    const renewalDue = String(e.renewal || '').toUpperCase() === 'DUE SOON';
    if (status === 'NOT AUTHORIZED') return 'DENIED';
    if (status === 'ACTION REQUIRED' || status === 'TRAINING INCOMPLETE') return 'AWAITING_REVIEW';
    if (authorized && renewalDue) return 'CONDITIONAL';
    if (authorized) return 'AUTHORIZED';
    return 'AWAITING_REVIEW';
  }

  const AUTH_CATEGORY_META = {
    AUTHORIZED: { label: 'AUTHORIZED', color: '#4ADE80' },
    CONDITIONAL: { label: 'CONDITIONALLY AUTHORIZED', color: '#FBBF24' },
    AWAITING_REVIEW: { label: 'AWAITING REVIEW', color: '#93C5FD' },
    DENIED: { label: 'DENIED / NOT AUTHORIZED', color: '#FCA5A5' },
  };

  function demoAuthorizationSummary() {
    return DEMO_WORKFORCE.reduce((a, e) => {
      const c = demoAuthorizationCategory(e);
      a[c] = (a[c] || 0) + 1;
      return a;
    }, {});
  }

  function demoAuthorizationFiltered() {
    return DEMO_WORKFORCE.filter(e => {
      const quick = authState.quickFilter === 'ALL' || demoAuthorizationCategory(e) === authState.quickFilter;
      const search = !authState.search || String(e.name || '').toLowerCase().includes(authState.search.toLowerCase());
      return quick && search;
    });
  }

  function demoAuthorizationCard(e) {
    const cat = demoAuthorizationCategory(e);
    const meta = AUTH_CATEGORY_META[cat];
    return `
      <div class="comp-card" style="padding:18px;margin-top:12px">
        <div style="display:flex;justify-content:space-between;gap:14px;flex-wrap:wrap;align-items:flex-start">
          <div>
            <div style="font-size:16px;font-weight:800;color:var(--white)">${demoEsc(e.name)}</div>
            <div class="comp-history" style="margin-top:4px">${demoEsc(e.scope)}</div>
          </div>
          <div style="font-weight:800;color:${meta.color}">${meta.label}</div>
        </div>
        <div style="display:flex;gap:10px;margin-top:14px;flex-wrap:wrap">
          <button type="button" class="secondary-btn" onclick="CorevianDemo.openPassport(${e.id})">View Qualification File</button>
          <button type="button" class="secondary-btn" onclick="CorevianDemo.openEligibility(${e.id})">Assignment Eligibility</button>
        </div>
      </div>`;
  }

  function renderDemoAuthorization() {
    const root = document.getElementById('contentInner');
    if (!root) return;
    const s = demoAuthorizationSummary();
    const list = demoAuthorizationFiltered();

    root.innerHTML = `
      <div class="unit-header">
        <div class="unit-eyebrow">FINAL QUALIFICATION CONTROL · SIMULATED</div>
        <div class="unit-title">Operational Authorization</div>
        <div class="unit-subtitle">Training completion does not equal authorization to operate independently. Authorization is a separate, documented leadership decision — reviewed here across the full simulated workforce.</div>
      </div>
      ${SIM_BANNER}
      <div class="stat-grid">
        ${demoAuthMetric('ALL', DEMO_WORKFORCE.length, 'All Records')}
        ${demoAuthMetric('AUTHORIZED', s.AUTHORIZED || 0, 'Authorized')}
        ${demoAuthMetric('CONDITIONAL', s.CONDITIONAL || 0, 'Conditionally Authorized')}
        ${demoAuthMetric('AWAITING_REVIEW', s.AWAITING_REVIEW || 0, 'Awaiting Review')}
        ${demoAuthMetric('DENIED', s.DENIED || 0, 'Denied / Not Authorized')}
      </div>
      <div class="comp-card" style="padding:16px;margin-top:14px;display:flex;gap:10px;flex-wrap:wrap;align-items:center">
        <input id="demoAuthSearch" class="comp-select" style="flex:1;min-width:180px" placeholder="Search employee" value="${demoEsc(authState.search)}">
        <button type="button" class="secondary-btn" id="demoAuthClearFilters">Clear Filters</button>
      </div>
      ${demoNotice(list.length + ' of ' + DEMO_WORKFORCE.length + ' simulated employee records shown.')}
      <div>${list.map(demoAuthorizationCard).join('') || demoNotice('No simulated employee matches the current filter.')}</div>
    `;

    document.querySelectorAll('[data-demo-auth-metric]').forEach(el => el.addEventListener('click', () => { authState.quickFilter = el.dataset.demoAuthMetric; renderDemoAuthorization(); }));
    const searchInput = document.getElementById('demoAuthSearch');
    if (searchInput) searchInput.addEventListener('input', e => { authState.search = e.target.value; renderDemoAuthorization(); });
    const clearBtn = document.getElementById('demoAuthClearFilters');
    if (clearBtn) clearBtn.addEventListener('click', () => { authState.quickFilter = 'ALL'; authState.search = ''; renderDemoAuthorization(); });
  }

  function demoAuthMetric(key, value, label) {
    const active = authState.quickFilter === key;
    return `<div class="stat-card" data-demo-auth-metric="${key}" style="cursor:pointer;${active ? 'border-color:var(--teal)' : ''}"><div class="stat-num">${value}</div><div class="stat-label">${label}</div></div>`;
  }

  // ══════════════════════════════════════════════════════════════
  // EXPANDED — Operational Endorsements (list view). Endorsement
  // status is derived from the same two fields Recertification uses
  // (authorization, renewal) applied to the employee's own recorded
  // scope — deliberately not inventing separate per-endorsement
  // effective/expiration dates, since DEMO_WORKFORCE has no such
  // field and fabricating one here would be a fact not present in
  // the approved dataset. "Effective" status is shown instead of an
  // invented date.
  // ══════════════════════════════════════════════════════════════
  const endorseState = { quickFilter: 'ALL', search: '', scope: 'ALL' };

  function demoEndorsementStatus(e) {
    const authorized = String(e.authorization || '').toUpperCase() === 'AUTHORIZED';
    const renewalDue = String(e.renewal || '').toUpperCase() === 'DUE SOON';
    if (!authorized) return 'NOT_ENDORSED';
    if (renewalDue) return 'ENDORSED_RENEWAL_DUE';
    return 'ENDORSED';
  }

  const ENDORSEMENT_META = {
    ENDORSED: { label: 'ENDORSED — EFFECTIVE', color: '#4ADE80' },
    ENDORSED_RENEWAL_DUE: { label: 'ENDORSED — RENEWAL DUE', color: '#FBBF24' },
    NOT_ENDORSED: { label: 'NOT ENDORSED', color: '#FCA5A5' },
  };

  function demoEndorsementFiltered() {
    return DEMO_WORKFORCE.filter(e => {
      const quick = endorseState.quickFilter === 'ALL' || demoEndorsementStatus(e) === endorseState.quickFilter;
      const scope = endorseState.scope === 'ALL' || e.scope === endorseState.scope;
      const search = !endorseState.search || String(e.name || '').toLowerCase().includes(endorseState.search.toLowerCase());
      return quick && scope && search;
    });
  }

  function demoEndorsementCard(e) {
    const status = demoEndorsementStatus(e);
    const meta = ENDORSEMENT_META[status];
    return `
      <div class="comp-card" style="padding:18px;margin-top:12px">
        <div style="display:flex;justify-content:space-between;gap:14px;flex-wrap:wrap;align-items:flex-start">
          <div>
            <div style="font-size:16px;font-weight:800;color:var(--white)">${demoEsc(e.name)}</div>
            <div class="comp-history" style="margin-top:4px">Endorsed category: ${demoEsc(e.scope)}</div>
          </div>
          <div style="font-weight:800;color:${meta.color}">${meta.label}</div>
        </div>
        <div class="comp-history" style="margin-top:10px">Additional service categories remain controlled until their own endorsement evidence is satisfied — not implied by this record.</div>
      </div>`;
  }

  function renderDemoEndorsements() {
    const root = document.getElementById('contentInner');
    if (!root) return;
    const counts = { ENDORSED: 0, ENDORSED_RENEWAL_DUE: 0, NOT_ENDORSED: 0 };
    DEMO_WORKFORCE.forEach(e => { counts[demoEndorsementStatus(e)]++; });
    const list = demoEndorsementFiltered();
    const scopeOptions = ['ALL', ...scopesList()].map(sc => `<option value="${demoEsc(sc)}" ${endorseState.scope === sc ? 'selected' : ''}>${sc === 'ALL' ? 'All service categories' : demoEsc(sc)}</option>`).join('');

    root.innerHTML = `
      <div class="unit-header">
        <div class="unit-eyebrow">CONTROLLED ENDORSEMENT MATRIX · SIMULATED</div>
        <div class="unit-title">Operational Endorsements</div>
        <div class="unit-subtitle">Approved service scope per employee. Qualification is never treated as unlimited permission for every service category.</div>
      </div>
      ${SIM_BANNER}
      <div class="stat-grid">
        ${demoEndorseMetric('ALL', DEMO_WORKFORCE.length, 'All Records')}
        ${demoEndorseMetric('ENDORSED', counts.ENDORSED, 'Endorsed — Effective')}
        ${demoEndorseMetric('ENDORSED_RENEWAL_DUE', counts.ENDORSED_RENEWAL_DUE, 'Endorsed — Renewal Due')}
        ${demoEndorseMetric('NOT_ENDORSED', counts.NOT_ENDORSED, 'Not Endorsed')}
      </div>
      <div class="comp-card" style="padding:16px;margin-top:14px;display:flex;gap:10px;flex-wrap:wrap;align-items:center">
        <input id="demoEndorseSearch" class="comp-select" style="flex:1;min-width:180px" placeholder="Search employee" value="${demoEsc(endorseState.search)}">
        <select class="comp-select" id="demoEndorseScope" style="min-width:220px">${scopeOptions}</select>
        <button type="button" class="secondary-btn" id="demoEndorseClearFilters">Clear Filters</button>
      </div>
      ${demoNotice(list.length + ' of ' + DEMO_WORKFORCE.length + ' simulated employee records shown.')}
      <div>${list.map(demoEndorsementCard).join('') || demoNotice('No simulated employee matches the current filter.')}</div>
    `;

    document.querySelectorAll('[data-demo-endorse-metric]').forEach(el => el.addEventListener('click', () => { endorseState.quickFilter = el.dataset.demoEndorseMetric; renderDemoEndorsements(); }));
    const searchInput = document.getElementById('demoEndorseSearch');
    if (searchInput) searchInput.addEventListener('input', e => { endorseState.search = e.target.value; renderDemoEndorsements(); });
    const scopeSelect = document.getElementById('demoEndorseScope');
    if (scopeSelect) scopeSelect.addEventListener('change', e => { endorseState.scope = e.target.value; renderDemoEndorsements(); });
    const clearBtn = document.getElementById('demoEndorseClearFilters');
    if (clearBtn) clearBtn.addEventListener('click', () => { endorseState.quickFilter = 'ALL'; endorseState.search = ''; endorseState.scope = 'ALL'; renderDemoEndorsements(); });
  }

  function demoEndorseMetric(key, value, label) {
    const active = endorseState.quickFilter === key;
    return `<div class="stat-card" data-demo-endorse-metric="${key}" style="cursor:pointer;${active ? 'border-color:var(--teal)' : ''}"><div class="stat-num">${value}</div><div class="stat-label">${label}</div></div>`;
  }

  // ══════════════════════════════════════════════════════════════
  // EXPANDED — Recertification & Renewals (list view). Derived
  // directly from the existing `renewal` field.
  //
  // HONEST LIMITATION, stated rather than worked around: the
  // approved 56-record dataset contains only CURRENT (52) and
  // DUE SOON (4) renewal values — no OVERDUE example exists. This
  // screen shows that truthfully rather than inventing an overdue
  // record. If you want an overdue example demonstrated, say so and
  // I'll add one as an explicit, flagged change to the dataset —
  // not silently.
  // ══════════════════════════════════════════════════════════════
  const recertState = { quickFilter: 'ALL', search: '' };

  function demoRecertStatus(e) {
    const renewal = String(e.renewal || '').toUpperCase();
    if (/OVERDUE|EXPIRED/.test(renewal)) return 'OVERDUE';
    if (renewal === 'DUE SOON') return 'DUE_SOON';
    return 'CURRENT';
  }

  const RECERT_META = {
    CURRENT: { label: 'CURRENT', color: '#4ADE80' },
    DUE_SOON: { label: 'APPROACHING RENEWAL', color: '#FBBF24' },
    OVERDUE: { label: 'OVERDUE / EXPIRED', color: '#FCA5A5' },
  };

  function demoRecertFiltered() {
    return DEMO_WORKFORCE.filter(e => {
      const quick = recertState.quickFilter === 'ALL' || demoRecertStatus(e) === recertState.quickFilter;
      const search = !recertState.search || String(e.name || '').toLowerCase().includes(recertState.search.toLowerCase());
      return quick && search;
    });
  }

  function demoRecertCard(e) {
    const status = demoRecertStatus(e);
    const meta = RECERT_META[status];
    return `
      <div class="comp-card" style="padding:18px;margin-top:12px">
        <div style="display:flex;justify-content:space-between;gap:14px;flex-wrap:wrap;align-items:flex-start">
          <div>
            <div style="font-size:16px;font-weight:800;color:var(--white)">${demoEsc(e.name)}</div>
            <div class="comp-history" style="margin-top:4px">${demoEsc(e.scope)}</div>
          </div>
          <div style="font-weight:800;color:${meta.color}">${meta.label}</div>
        </div>
        <div style="display:flex;gap:10px;margin-top:14px;flex-wrap:wrap">
          <button type="button" class="secondary-btn" onclick="CorevianDemo.openPassport(${e.id})">View Qualification File</button>
        </div>
      </div>`;
  }

  function renderDemoRecertification() {
    const root = document.getElementById('contentInner');
    if (!root) return;
    const counts = { CURRENT: 0, DUE_SOON: 0, OVERDUE: 0 };
    DEMO_WORKFORCE.forEach(e => { counts[demoRecertStatus(e)]++; });
    const list = demoRecertFiltered();

    root.innerHTML = `
      <div class="unit-header">
        <div class="unit-eyebrow">ONGOING QUALIFICATION CONTROL · SIMULATED</div>
        <div class="unit-title">Recertification &amp; Renewal Tracking</div>
        <div class="unit-subtitle">Controlled renewal requirements after initial qualification, tracked across the full simulated workforce.</div>
      </div>
      ${SIM_BANNER}
      ${counts.OVERDUE === 0 ? demoNotice('No simulated employee currently has an overdue or expired renewal in this dataset — Current and Approaching Renewal are the only statuses present today.') : ''}
      <div class="stat-grid">
        ${demoRecertMetric('ALL', DEMO_WORKFORCE.length, 'All Records')}
        ${demoRecertMetric('CURRENT', counts.CURRENT, 'Current')}
        ${demoRecertMetric('DUE_SOON', counts.DUE_SOON, 'Approaching Renewal')}
        ${demoRecertMetric('OVERDUE', counts.OVERDUE, 'Overdue / Expired')}
      </div>
      <div class="comp-card" style="padding:16px;margin-top:14px;display:flex;gap:10px;flex-wrap:wrap;align-items:center">
        <input id="demoRecertSearch" class="comp-select" style="flex:1;min-width:180px" placeholder="Search employee" value="${demoEsc(recertState.search)}">
        <button type="button" class="secondary-btn" id="demoRecertClearFilters">Clear Filters</button>
      </div>
      ${demoNotice(list.length + ' of ' + DEMO_WORKFORCE.length + ' simulated employee records shown.')}
      <div>${list.map(demoRecertCard).join('') || demoNotice('No simulated employee matches the current filter.')}</div>
    `;

    document.querySelectorAll('[data-demo-recert-metric]').forEach(el => el.addEventListener('click', () => { recertState.quickFilter = el.dataset.demoRecertMetric; renderDemoRecertification(); }));
    const searchInput = document.getElementById('demoRecertSearch');
    if (searchInput) searchInput.addEventListener('input', e => { recertState.search = e.target.value; renderDemoRecertification(); });
    const clearBtn = document.getElementById('demoRecertClearFilters');
    if (clearBtn) clearBtn.addEventListener('click', () => { recertState.quickFilter = 'ALL'; recertState.search = ''; renderDemoRecertification(); });
  }

  function demoRecertMetric(key, value, label) {
    const active = recertState.quickFilter === key;
    return `<div class="stat-card" data-demo-recert-metric="${key}" style="cursor:pointer;${active ? 'border-color:var(--teal)' : ''}"><div class="stat-num">${value}</div><div class="stat-label">${label}</div></div>`;
  }

  function renderDemoSoloRouteAuthorization() {
    const root = document.getElementById('contentInner');
    if (!root) return;
    const jordan = DEMO_WORKFORCE.find(x => x.id === JORDAN_ID);
    root.innerHTML = `
      <div class="unit-header">
        <div class="unit-eyebrow">LEADERSHIP QUALIFICATION TRAINING · SIMULATED</div>
        <div class="unit-title">Solo Route Authorization Training</div>
        <div class="unit-subtitle">CVN-LSRAT-001 — leadership training for evaluating and authorizing independent route operation. Authorization is a documented leadership decision, never an automatic result of course completion.</div>
      </div>
      ${SIM_BANNER}
      <div class="comp-card" style="padding:20px;margin-top:14px">
        <div class="comp-code">STANDARD</div>
        <div style="margin-top:8px;font-weight:800;color:var(--white)">CVN-LSRAT-001 · 90% Pass Standard</div>
        <div class="comp-history" style="margin-top:10px">Trains leadership to review the complete qualification file — training, competency, field readiness, controlled documents, service scope — before issuing Operational Authorization for independent route operation.</div>
      </div>
      <div class="comp-card" style="padding:20px;margin-top:14px">
        <div class="comp-code">WORKED EXAMPLE</div>
        <div style="margin-top:8px;font-weight:800;color:var(--white)">${demoEsc(jordan.name)} — Complete Evidence Chain</div>
        ${demoGateLine(String(jordan.training).toUpperCase() === 'PASS', 'Training', jordan.training)}
        ${demoGateLine(String(jordan.competency).toUpperCase() === 'QUALIFIED', 'Competency', jordan.competency)}
        ${demoGateLine(String(jordan.field).toUpperCase() === 'READY', 'Field Readiness', jordan.field)}
        ${demoGateLine(!/OVERDUE|OUTSTANDING|INCOMPLETE|ACTION REQUIRED/.test(String(jordan.documents).toUpperCase()), 'Controlled Documents', jordan.documents)}
        ${demoGateLine(String(jordan.authorization).toUpperCase() === 'AUTHORIZED', 'Operational Authorization', jordan.authorization)}
        <div class="comp-history" style="margin-top:10px">This is what a leadership reviewer checks before authorizing solo route operation — every gate independently satisfied, never inferred from training completion alone.</div>
      </div>
      <div class="comp-card" style="padding:16px;margin-top:14px">
        <button type="button" class="secondary-btn" onclick="CorevianDemo.openPassport(${jordan.id})">View ${demoEsc(jordan.name)}'s Qualification Passport</button>
      </div>
    `;
  }

  // ══════════════════════════════════════════════════════════════
  // CONTROLLED DOCUMENTS — approved static snapshot + simulated
  // workforce status. The companion asset contains the real approved
  // metadata and content_text for all 37 controlled documents. This
  // presentation layer never queries Supabase for document content.
  // ══════════════════════════════════════════════════════════════
  const DOCUMENT_CATALOG = Array.isArray(window.COREVIAN_DEMO_DOCUMENTS)
    ? window.COREVIAN_DEMO_DOCUMENTS.map(d => ({
        code: d.document_code,
        title: d.title,
        type: d.document_type,
        department: d.department,
        version: d.version_number,
        status: d.version_status,
        effective: d.effective_date,
        review: d.review_due_date,
        ackRequired: !!d.acknowledgment_required,
        trainingRequired: !!d.training_required,
        competencyRequired: !!d.competency_required,
        contentText: d.content_text || ''
      }))
    : [];

  function demoDocCategory(code) {
    if (code.startsWith('CHL-POL-')) return code === 'CHL-POL-015' ? 'bbp' : 'policies';
    if (code.startsWith('CHL-SOP-')) return 'sops';
    if (code.startsWith('CHL-BBP-') || code.startsWith('CHL-ECP-')) return 'bbp';
    return 'other';
  }

  function isOccupationalHealthRecordTemplate(doc) {
    return /^CHL-BBP-00[1-9]$/.test(String(doc.code || ''));
  }

  const DOC_CATEGORY_META = {
    policies: { label: 'Policies', eyebrow: 'GOVERNANCE' },
    sops:     { label: 'Standard Operating Procedures', eyebrow: 'OPERATIONS' },
    bbp:      { label: 'BBP & Occupational Exposure', eyebrow: 'SAFETY & EXPOSURE' },
    other:    { label: 'Other Controlled Documents', eyebrow: 'CONTROLLED KNOWLEDGE' },
  };

  function demoStringHash(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = (Math.imul(h, 31) + str.charCodeAt(i)) >>> 0;
    return h;
  }

  function demoDocumentAssignmentState(employee, doc) {
    if (!doc.ackRequired) return 'ON_FILE';
    const bucket = demoStringHash(String(employee.id) + '|' + doc.code) % 100;
    const q = demoCategory(employee);
    let thresholds;
    if (q.ready) thresholds = [80, 93, 98];
    else if (q.notAuthorized) thresholds = [40, 70, 88];
    else thresholds = [55, 80, 93];
    if (bucket < thresholds[0]) return 'ACKNOWLEDGED';
    if (bucket < thresholds[1]) return 'REQUIRED';
    if (bucket < thresholds[2]) return 'OVERDUE';
    return 'NOT_ASSIGNED';
  }

  const DOC_STATE_META = {
    ACKNOWLEDGED: { label: 'ACKNOWLEDGED', color: '#4ADE80' },
    REQUIRED:     { label: 'ACKNOWLEDGMENT REQUIRED', color: '#FBBF24' },
    OVERDUE:      { label: 'OVERDUE', color: '#FCA5A5' },
    NOT_ASSIGNED: { label: 'NOT ASSIGNED', color: '#94A3B8' },
    ON_FILE:      { label: 'CONTROLLED RECORD · NO ACKNOWLEDGMENT REQUIRED', color: '#7DD3FC' },
  };

  function demoAcknowledgedDateFor(employee, doc) {
  const h = demoStringHash(String(employee.id) + '|' + doc.code + '|date');
  const effective = new Date(doc.effective + 'T12:00:00');
  const today = new Date();
  today.setHours(12, 0, 0, 0);

  const daysAvailable = Math.max(
    0,
    Math.floor((today - effective) / 86400000)
  );

  const offset = daysAvailable > 0
    ? h % (daysAvailable + 1)
    : 0;

  effective.setDate(effective.getDate() + offset);

  return effective.toISOString().slice(0, 10);
}

  function demoFormatDate(value) {
    if (!value) return '—';
    const d = new Date(String(value) + 'T12:00:00');
    if (Number.isNaN(d.getTime())) return demoEsc(value);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }

  function demoRequirementPill(label, required) {
    return `<span style="display:inline-flex;align-items:center;border:1px solid ${required ? 'rgba(94,212,207,.45)' : 'rgba(148,163,184,.3)'};background:${required ? 'rgba(25,181,176,.08)' : 'rgba(148,163,184,.06)'};color:${required ? '#A7F3EF' : '#CBD5E1'};border-radius:999px;padding:7px 10px;font-size:11px;font-weight:800">${demoEsc(label)} ${required ? 'REQUIRED' : 'NOT REQUIRED'}</span>`;
  }

  let selectedDemoDocsEmployeeId = JORDAN_ID;
  let selectedDemoDocsCategory = null;

  function demoDocMetricsFor(employee) {
    const ackDocs = DOCUMENT_CATALOG.filter(d => d.ackRequired);
    const states = ackDocs.map(d => demoDocumentAssignmentState(employee, d));
    return {
      assigned: states.filter(s => s !== 'NOT_ASSIGNED').length,
      acknowledged: states.filter(s => s === 'ACKNOWLEDGED').length,
      required: states.filter(s => s === 'REQUIRED').length,
      overdue: states.filter(s => s === 'OVERDUE').length
    };
  }

  function demoDocMetricCard(value, label) {
    return `<div class="stat-card"><div class="stat-num">${value}</div><div class="stat-label">${label}</div></div>`;
  }

  function demoDocCategoryCard(key, count) {
    const meta = DOC_CATEGORY_META[key];
    const active = selectedDemoDocsCategory === key;
    return `<button type="button" class="comp-card" data-demo-doc-category="${key}" style="text-align:left;cursor:pointer;padding:18px;${active ? 'border-color:var(--teal)' : ''}">
      <div class="comp-code">${demoEsc(meta.eyebrow)}</div>
      <div style="font-size:18px;font-weight:800;color:var(--white);margin-top:6px">${demoEsc(meta.label)}</div>
      <div style="font-size:28px;font-weight:800;color:#5ED4CF;margin-top:10px">${count}</div>
    </button>`;
  }

  function demoDocumentRow(employee, doc) {
    const personalRecord = isOccupationalHealthRecordTemplate(doc);
    const state = personalRecord ? 'ON_FILE' : demoDocumentAssignmentState(employee, doc);
    const meta = DOC_STATE_META[state];
    const ackLine = state === 'ACKNOWLEDGED'
      ? `<div class="comp-history" style="margin-top:6px">Acknowledged ${demoFormatDate(demoAcknowledgedDateFor(employee, doc))} · Version-locked to ${demoEsc(doc.code)} v${demoEsc(doc.version)}</div>`
      : personalRecord
        ? `<div class="comp-history" style="margin-top:6px">Approved blank controlled template · No completed personal medical or occupational-health record is simulated.</div>`
        : '';
    return `<div class="comp-card" style="padding:16px;margin-top:12px">
      <div style="display:flex;justify-content:space-between;gap:14px;flex-wrap:wrap;align-items:flex-start">
        <div style="flex:1;min-width:240px">
          <div class="comp-code">${demoEsc(doc.code)}</div>
          <div style="font-weight:800;color:var(--white);margin-top:4px">${demoEsc(doc.title)}</div>
          <div class="comp-history" style="margin-top:6px">Version ${demoEsc(doc.version)} · Effective ${demoFormatDate(doc.effective)} · Review ${demoFormatDate(doc.review)}</div>
          ${ackLine}
        </div>
        <div style="text-align:right">
          <div style="font-weight:800;color:${meta.color};white-space:nowrap">${meta.label}</div>
          <button type="button" class="secondary-btn" style="margin-top:10px" onclick="CorevianDemo.openDocument('${demoEsc(doc.code)}', ${employee.id})">View Document</button>
        </div>
      </div>
    </div>`;
  }

  function openDemoControlledDocument(code, employeeId) {
    const doc = DOCUMENT_CATALOG.find(d => d.code === code);
    const employee = DEMO_WORKFORCE.find(e => e.id === Number(employeeId)) || DEMO_WORKFORCE[0];
    if (!doc || !employee) { alert('Simulated controlled-document record could not be found.'); return; }

    const existing = document.getElementById('demoControlledDocumentOverlay');
    if (existing) existing.remove();

    const personalRecord = isOccupationalHealthRecordTemplate(doc);
    const state = personalRecord ? 'ON_FILE' : demoDocumentAssignmentState(employee, doc);
    const meta = DOC_STATE_META[state];
    const acknowledged = state === 'ACKNOWLEDGED';
    const content = doc.contentText
      ? demoEsc(doc.contentText)
      : 'Controlled document text is unavailable in this presentation snapshot.';

    let complianceHtml;
    if (personalRecord) {
      complianceHtml = `<div class="comp-card" style="padding:18px;margin-top:16px;border-left:3px solid #7DD3FC;background:var(--navy2)">
        <div class="comp-code" style="color:#7DD3FC">CONTROLLED OCCUPATIONAL-HEALTH / COMPLIANCE TEMPLATE</div>
        <div class="comp-history" style="margin-top:8px">This Executive Demo displays the approved blank controlled template only. It does not create, populate, or simulate a completed personal medical or occupational-health record for ${demoEsc(employee.name)} or any other fictional employee.</div>
      </div>`;
    } else {
      complianceHtml = `<div class="comp-card" style="padding:18px;margin-top:16px;border-left:3px solid ${meta.color};background:var(--navy2)">
        <div class="comp-code">SIMULATED EMPLOYEE COMPLIANCE RECORD</div>
        <div style="display:flex;justify-content:space-between;gap:12px;flex-wrap:wrap;margin-top:8px">
          <div style="font-weight:800;color:var(--white)">${demoEsc(employee.name)}</div>
          <div style="font-weight:800;color:${meta.color}">${meta.label}</div>
        </div>
        ${acknowledged ? `<div class="comp-history" style="margin-top:8px">Version acknowledged: <strong style="color:var(--white)">${demoEsc(doc.version)}</strong><br>Simulated acknowledgment date: <strong style="color:var(--white)">${demoFormatDate(demoAcknowledgedDateFor(employee, doc))}</strong></div>` : `<div class="comp-history" style="margin-top:8px">No acknowledgment completion is shown for this simulated employee/document state.</div>`}
      </div>`;
    }

    const trainingEvidence = doc.trainingRequired
      ? `<div class="comp-history" style="margin-top:6px">Document control requires training. Simulated workforce training status: <strong style="color:var(--white)">${demoEsc(employee.training)}</strong>.</div>`
      : `<div class="comp-history" style="margin-top:6px">This controlled version does not carry a training-required flag.</div>`;
    const competencyEvidence = doc.competencyRequired
      ? `<div class="comp-history" style="margin-top:6px">Document control requires competency. Simulated workforce competency status: <strong style="color:var(--white)">${demoEsc(employee.competency)}</strong>.</div>`
      : `<div class="comp-history" style="margin-top:6px">This controlled version does not carry a competency-required flag.</div>`;

    const overlay = document.createElement('div');
    overlay.id = 'demoControlledDocumentOverlay';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:10000;background:rgba(5,17,31,.96);padding:22px;overflow:auto';
    overlay.innerHTML = `<div class="comp-card" style="max-width:1080px;width:100%;margin:0 auto;padding:28px;background:#071526;color:#F7FAFC;position:relative">
      <button type="button" class="secondary-btn" style="position:sticky;top:0;float:right;z-index:2" onclick="document.getElementById('demoControlledDocumentOverlay').remove()">Close</button>
      <div class="unit-eyebrow">CONTROLLED DOCUMENT RECORD · EXECUTIVE DEMO</div>
      <div class="unit-title" style="margin-top:6px;padding-right:90px">${demoEsc(doc.code)} — ${demoEsc(doc.title)}</div>
      <div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:14px">
        <span style="border:1px solid rgba(74,222,128,.35);background:rgba(74,222,128,.07);color:#86EFAC;border-radius:999px;padding:7px 10px;font-size:11px;font-weight:800">VERSION ${demoEsc(doc.version)} · ${demoEsc(String(doc.status).toUpperCase())}</span>
        <span style="border:1px solid rgba(148,163,184,.3);border-radius:999px;padding:7px 10px;font-size:11px;font-weight:800;color:#CBD5E1">${demoEsc(doc.department || 'Department not specified')}</span>
      </div>
      <div class="comp-card" style="padding:18px;margin-top:16px;background:var(--navy2)">
        <div class="comp-code">DOCUMENT CONTROL</div>
        <div class="comp-history" style="margin-top:8px"><strong style="color:var(--white)">Effective:</strong> ${demoFormatDate(doc.effective)} &nbsp; · &nbsp; <strong style="color:var(--white)">Review Due:</strong> ${demoFormatDate(doc.review)} &nbsp; · &nbsp; <strong style="color:var(--white)">Type:</strong> ${demoEsc(doc.type)}</div>
      </div>
      <div class="comp-card" style="padding:18px;margin-top:16px;background:var(--navy2)">
        <div class="comp-code">REQUIREMENTS</div>
        <div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px">
          ${demoRequirementPill('ACKNOWLEDGMENT', doc.ackRequired)}
          ${demoRequirementPill('TRAINING', doc.trainingRequired)}
          ${demoRequirementPill('COMPETENCY', doc.competencyRequired)}
        </div>
      </div>
      ${complianceHtml}
      ${personalRecord ? '' : `<div class="comp-card" style="padding:18px;margin-top:16px;background:var(--navy2)">
        <div class="comp-code">TRAINING &amp; QUALIFICATION RELATIONSHIP</div>
        ${trainingEvidence}
        ${competencyEvidence}
        <div class="comp-history" style="margin-top:6px">Operational authorization remains a separate leadership decision and is not created by viewing or acknowledging this document.</div>
      </div>`}
      <div class="comp-card" style="padding:20px;margin-top:16px;background:#FCFAF7;color:#0F172A;border-color:rgba(255,255,255,.18)">
        <div style="font-size:12px;font-weight:900;letter-spacing:.08em;color:#0F766E">CONTROLLED DOCUMENT CONTENT</div>
        <div style="margin-top:14px;white-space:pre-wrap;overflow-wrap:anywhere;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.65;color:#111827">${content}</div>
      </div>
      <div class="comp-notice" style="margin-top:16px">Approved controlled-document text is displayed from the static Executive Demo snapshot. Simulated workforce status is presentation-only and does not read or write production employee records.</div>
    </div>`;
    document.body.appendChild(overlay);
  }

  function renderDemoPolicies() {
    const root = document.getElementById('contentInner');
    if (!root) return;
    const emp = DEMO_WORKFORCE.find(x => x.id === selectedDemoDocsEmployeeId) || DEMO_WORKFORCE[0];

    if (!DOCUMENT_CATALOG.length) {
      root.innerHTML = `<div class="unit-header"><div class="unit-eyebrow">KNOWLEDGE &amp; DOCUMENT CONTROL · SIMULATED</div><div class="unit-title">Policies &amp; SOPs</div></div>${SIM_BANNER}${demoNotice('The approved controlled-document snapshot did not load. Confirm corevian-executive-demo-documents.js loads before corevian-executive-demo.js.')}`;
      return;
    }

    const m = demoDocMetricsFor(emp);
    const counts = { policies: 0, sops: 0, bbp: 0, other: 0 };
    DOCUMENT_CATALOG.forEach(d => { counts[demoDocCategory(d.code)]++; });
    const categoryGrid = `<div class="stat-grid">${demoDocCategoryCard('policies', counts.policies)}${demoDocCategoryCard('sops', counts.sops)}${demoDocCategoryCard('bbp', counts.bbp)}</div>`;

    const expanded = selectedDemoDocsCategory ? (() => {
      const meta = DOC_CATEGORY_META[selectedDemoDocsCategory];
      const docs = DOCUMENT_CATALOG.filter(d => demoDocCategory(d.code) === selectedDemoDocsCategory).sort((a, b) => a.code.localeCompare(b.code, undefined, { numeric: true }));
      return `<div style="margin-top:18px">
        <button type="button" class="secondary-btn" id="demoDocsCategoryBack">← All Categories</button>
        <div class="unit-eyebrow" style="margin-top:14px">${demoEsc(meta.eyebrow)}</div>
        <div style="font-size:20px;font-weight:800;color:var(--white);margin-top:4px">${demoEsc(meta.label)} · ${docs.length} document${docs.length === 1 ? '' : 's'}</div>
        ${docs.map(d => demoDocumentRow(emp, d)).join('')}
      </div>`;
    })() : '';

    root.innerHTML = `<div class="unit-header">
      <div class="unit-eyebrow">KNOWLEDGE &amp; DOCUMENT CONTROL · SIMULATED</div>
      <div class="unit-title">Policies &amp; SOPs</div>
      <div class="unit-subtitle">${DOCUMENT_CATALOG.length} approved controlled documents with full approved text. The catalog and document content are a static snapshot of Corevian's controlled-document system; per-employee assignment and acknowledgment status remains simulated and presentation-safe.</div>
    </div>
    ${SIM_BANNER}
    <div class="comp-card" style="padding:16px;margin-top:14px"><label class="comp-label">Employee</label>${demoEmployeeSelector(emp.id, "CorevianDemo.selectDocsEmployee(this.value)")}</div>
    <div class="stat-grid" style="margin-top:14px">${demoDocMetricCard(m.assigned, 'Assigned')}${demoDocMetricCard(m.acknowledged, 'Acknowledged')}${demoDocMetricCard(m.required, 'Action Required')}${demoDocMetricCard(m.overdue, 'Overdue')}</div>
    ${selectedDemoDocsCategory ? '' : categoryGrid}${expanded}`;

    document.querySelectorAll('[data-demo-doc-category]').forEach(el => el.addEventListener('click', () => { selectedDemoDocsCategory = el.getAttribute('data-demo-doc-category'); renderDemoPolicies(); }));
    const back = document.getElementById('demoDocsCategoryBack');
    if (back) back.addEventListener('click', () => { selectedDemoDocsCategory = null; renderDemoPolicies(); });
  }

  // ══════════════════════════════════════════════════════════════
  // DEMO-SAFE — Exceptions & Operational Risk
  // Mirrors renderExecutiveExceptionsRisk() in
  // corevian-university-executive-oversight.js field-for-field,
  // substituting DEMO_WORKFORCE for real workforce rows and
  // explainDemoQualificationStatus() for the real explanation
  // engine. Takes a container argument to match that function's
  // exact calling convention from corevian-university-2.js's
  // onAction('exceptions-risk') handler.
  // ══════════════════════════════════════════════════════════════
  function renderDemoExceptionsRisk(container) {
    if (!container) return;

    const exceptions = DEMO_WORKFORCE
      .map(row => ({ row, explanation: explainDemoQualificationStatus(row) }))
      .filter(x => !x.explanation.authorized || x.explanation.warnings.length > 0);

    container.innerHTML = `
      <div class="unit-header">
        <div class="unit-eyebrow">EXCEPTIONS &amp; OPERATIONAL RISK · SIMULATED</div>
        <div class="unit-title">What currently requires leadership attention</div>
        <div class="unit-subtitle">Every item below is generated from the same simulated workforce data and explanation logic used elsewhere in this demo — nothing here is computed independently. Service-scope/endorsement conflicts are not detected by any existing function and are intentionally not included.</div>
      </div>
      ${SIM_BANNER}
      <div class="comp-notice">
        ${exceptions.length} employee${exceptions.length === 1 ? '' : 's'} currently require attention,
        out of ${DEMO_WORKFORCE.length} total.
      </div>
      ${
        exceptions.length
          ? exceptions.map(({ row, explanation }) => {
              const color = explanation.authorized ? '#FBBF24' : '#FCA5A5';
              const items = [...explanation.blockers, ...explanation.warnings];
              return `
                <div class="comp-card" style="padding:16px;margin-top:12px;border-left:3px solid ${color}">
                  <div style="display:flex;justify-content:space-between;gap:12px;flex-wrap:wrap;align-items:baseline">
                    <div style="font-size:15px;font-weight:800;color:var(--white)">${demoEsc(row.name || 'Unnamed Employee')}</div>
                    <div style="font-size:11px;font-weight:800;color:${color}">${explanation.authorized ? 'ACTION REQUIRED' : 'NOT AUTHORIZED'}</div>
                  </div>
                  <div class="comp-history" style="margin-top:6px">${demoEsc(explanation.summary)}</div>
                  ${items.map(item => `
                    <div class="comp-history" style="margin-top:6px">
                      <strong style="color:var(--white)">${demoEsc(item.control)}:</strong> ${demoEsc(item.explanation)}
                      — <em>${demoEsc(item.nextAction)}</em>
                    </div>
                  `).join('')}
                </div>
              `;
            }).join('')
          : `<div class="comp-notice" style="margin-top:12px">No current exceptions — every simulated employee is fully ready.</div>`
      }
    `;
  }
  window.renderDemoExceptionsRisk = renderDemoExceptionsRisk;


  // ───────────────────────────────────────────────────────────────
  // Direct-call wrapper — Operational Authorization, Operational
  // Endorsements, Recertification & Renewals.
  //
  // These three are invoked by the dashboard's onAction() callback
  // in corevian-university-2.js, which calls them DIRECTLY —
  // window.showView() is never involved, so the showView shim above
  // never sees these calls. Confirmed by direct inspection of that
  // onAction handler.
  //
  // Each real function's own guard (canApproveEndorsements(),
  // canIssueOperationalAuthorization(), canManageRecertification())
  // is written as `!demoMode && [...]`, so it always denies while a
  // demo is active — there is no branch inside them that reaches a
  // demo screen. This wraps each function at the window level, the
  // same technique already used for showView, so corevian-university-2.js
  // itself is never edited: three plain top-level `function`
  // declarations attach to `window.<name>` automatically, so they can
  // be safely replaced with a demo-aware wrapper the same way
  // window.showView was.
  //
  // `demoMode` itself is declared with `let` at the top level of
  // corevian-university-2.js. A `let`/`const` at classic-script top
  // level does not become a `window` property, but it IS visible as a
  // bare identifier from any other classic <script> on the same page
  // (verified directly, not assumed) — which is exactly how
  // canApproveEndorsements() and friends already read it. `typeof
  // demoMode !== 'undefined'` is used before reading it so this can
  // never throw if load order were ever different than expected.
  // ───────────────────────────────────────────────────────────────
  function isRealDemoModeActive() {
    return typeof demoMode !== 'undefined' && demoMode === true;
  }

  function wrapDirectDashboardCall(fnName, demoFn) {
    const original = window[fnName];
    if (typeof original !== 'function') {
      console.error('CorevianDemo: window.' + fnName + ' was not found — its demo wrapper was not installed.');
      return;
    }
    if (original.__corevianDemoWrapped) return;

    window[fnName] = function (...args) {
      if (isRealDemoModeActive() && typeof demoFn === 'function') {
        return demoFn();
      }
      return original.apply(this, args);
    };
    window[fnName].__corevianDemoWrapped = true;
  }

  wrapDirectDashboardCall('renderOperationalAuthorization', renderDemoAuthorization);
  wrapDirectDashboardCall('renderOperationalEndorsements', renderDemoEndorsements);
  wrapDirectDashboardCall('renderRecertificationTracking', renderDemoRecertification);

  window.CorevianDemo = {
    openPassport: openDemoQualificationPassport,
    openEligibility: openDemoAssignmentEligibility,
    openDocument: openDemoControlledDocument,
    selectCompetency: v => { selectedDemoCompetencyId = Number(v); renderDemoCompetencyEvaluation(); },
    selectField: v => { selectedDemoFieldId = Number(v); renderDemoFieldTraining(); },
    selectDocsEmployee: v => { selectedDemoDocsEmployeeId = Number(v); renderDemoPolicies(); },
  };

  if (typeof window.showView === 'function') {
    const liveShowView = window.showView;
    const DEMO_ROUTES = {
      competency: renderDemoCompetencyEvaluation,
      fieldtraining: renderDemoFieldTraining,
      endorsements: renderDemoEndorsements,
      authorization: renderDemoAuthorization,
      recertification: renderDemoRecertification,
      soloroutetraining: renderDemoSoloRouteAuthorization,
    };
    DEMO_ROUTES.policies = renderDemoPolicies;

    window.showView = function (view, el) {
      if (window.demoMode && DEMO_ROUTES[view]) {
        document.querySelectorAll('.nav-btn').forEach(b => b.classList.remove('active'));
        if (el) el.classList.add('active');
        DEMO_ROUTES[view]();
        return;
      }
      return liveShowView(view, el);
    };
  } else {
    console.error('CorevianDemo: window.showView was not found. Competency/Field/Endorsements/Authorization/Recertification/SoloRouteTraining demo screens cannot be routed. Workforce Readiness and per-employee buttons are unaffected.');
  }

  function attachDemoKnowledgeControlHandlers() {
    const docsBtn = document.getElementById('navDocuments');
    const passportBtn = document.getElementById('navPassport');

    if (docsBtn && !docsBtn.__corevianDemoHandlerAttached) {
      docsBtn.__corevianDemoHandlerAttached = true;
      docsBtn.addEventListener('click', () => {
        if (window.demoMode) renderDemoPolicies();
      });
    }
    if (passportBtn && !passportBtn.__corevianDemoHandlerAttached) {
      passportBtn.__corevianDemoHandlerAttached = true;
      passportBtn.addEventListener('click', () => {
        if (window.demoMode) openDemoQualificationPassport(JORDAN_ID);
      });
    }
    return !!(docsBtn && passportBtn);
  }

  (function waitForKnowledgeControlNav(attemptsLeft) {
    if (attachDemoKnowledgeControlHandlers()) return;
    if (attemptsLeft <= 0) {
      console.warn('CorevianDemo: #navDocuments/#navPassport were not found after retrying — Knowledge & Document Control demo handlers were not attached.');
      return;
    }
    setTimeout(() => waitForKnowledgeControlNav(attemptsLeft - 1), 300);
  })(20);
})();